import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getBundle } from "../../utils/ups";
import {
    setUser,
    receivePreferences,
} from "../../actions/Preferences/dispatchers";
import { BUNDLE_ID } from "../../constants/userPreferences";
import useUserInfo from "../../hooks/useUserInfo";

export default function UpsClient() {
    const dispatch = useDispatch();
    const { id, isLoading } = useUserInfo();
    useEffect(() => {
        if (isLoading) {
            return;
        }
        dispatch(setUser(id));
        getBundle(id, BUNDLE_ID).then((bundle) => {
            dispatch(receivePreferences(id, bundle));
        });
    }, [id, isLoading]);
    return null;
}
